module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-kaoawase-venue-460d60a43c7482a76558beaa67840357.jpg";